import * as React from 'react';
import { memo } from 'react';

export type TextProps = {
	tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'div' | 'span';
	size: 's' | 'm' | 'l' | 'xl' | 'xxl';
	textStyle?: '' | 'light' | 'regular' | 'semibold' | 'bold' | 'black';
	align?: '' | 'center' | 'left';
	text?: string;
	children?: Object;
};

export const Text = ({ tag, size, textStyle, align = '', text, children }: TextProps) => {
	const CustomTextTag: any = `${tag}`;

	const getClassNames = (): string => {
		const classes: string[] = [];

		if (size) {
			classes.push(`a-text--size-${size}`);
		}

		if (textStyle) {
			classes.push(`a-text--style-${textStyle}`);
		}

		if (align) {
			classes.push(`a-text--align-${align}`);
		}

		return classes.join(' ');
	};

	return <CustomTextTag className={`a-text ${getClassNames()}`}>{children || text}</CustomTextTag>;
};

export default memo(Text, (prevProps, nextProps) => {
	return (
		prevProps.text === nextProps.text &&
		prevProps.children === nextProps.children &&
		prevProps.tag === nextProps.tag
	);
});
